import { create } from 'zustand';

// Simple store for floating window open/close state
interface FloatingWindowsState {
    particleCount: boolean;
    energyDistribution: boolean;
    velocityHistogram: boolean;
    speciesPercentages: boolean;
    energyGraph: boolean;
}

interface FloatingWindowsStore extends FloatingWindowsState {
    toggleWindow: (key: keyof FloatingWindowsState) => void;
    closeWindow: (key: keyof FloatingWindowsState) => void;
    openWindow: (key: keyof FloatingWindowsState) => void;
}

export const useFloatingWindowsStore = create<FloatingWindowsStore>((set) => ({
    particleCount: false,
    energyDistribution: false,
    velocityHistogram: false,
    speciesPercentages: false,
    energyGraph: false,

    toggleWindow: (key) => set((state) => ({ [key]: !state[key] })),
    closeWindow: (key) => set(() => ({ [key]: false })),
    openWindow: (key) => set(() => ({ [key]: true })),
}));
